import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalButton, NavigateLinks } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { AgendasTable } from './components';
import { SearchBar } from './components';
import { Add as AddIcon } from '@mui/icons-material';
import { childrenAttendTrackPageBreadcrumbs } from './config';
import { AgendaFilter } from './models';

import styles from './Agendas.module.css';
import dayjs from 'dayjs';

export const Agendas = () => {
  const navigate = useNavigate();

  const breadcrumbs = useMemo(
    () => childrenAttendTrackPageBreadcrumbs(navigate),
    []
  );

  const filterInitialValues: AgendaFilter = useMemo(
    () => ({
      dateOpenFrom: dayjs().format('MM/DD/YYYY'),
      dateOpenTo: dayjs().add(15, 'day').format('MM/DD/YYYY'),
    }),
    []
  );

  const filterDefaultValues: AgendaFilter = useMemo(() => {
    const storedFilters = JSON.parse(
      localStorage.getItem('AGENDAS-FILTERS') || '{}'
    );

    return {
      ...filterInitialValues,
      ...storedFilters,
    };
  }, []);

  const [agendasFilter, setAgendasFilter] =
    useState<AgendaFilter>(filterDefaultValues);

  return (
    <section className={styles.container}>
      <NavigateLinks actualPage='Agendas' breadcrumbs={breadcrumbs} />
      <div className={styles.actions}>
        <GlobalButton
          variant={GlobalButtonVariant.primaryButton}
          action={() => navigate('create')}
        >
          <AddIcon />
          Agregar agenda
        </GlobalButton>
      </div>
      <SearchBar
        filterInitialValues={filterInitialValues}
        filterDefaultValues={filterDefaultValues}
        search={(data) => setAgendasFilter(data)}
      />
      <AgendasTable agendasFilter={agendasFilter} />
    </section>
  );
};

export default Agendas;
